import { defaultLocale, isSupportedLocale, type Locale } from '@shared/locales';

/**
 * Groups `import.meta.glob` results by locale: `<slug>.md` is the default
 * locale, `<slug>.<locale>.md` a translation.
 */
export function groupByLocale<T>(
  files: Record<string, string>,
  build: (slug: string, raw: string, locale: Locale) => T,
): Map<Locale, Map<string, T>> {
  const byLocale = new Map<Locale, Map<string, T>>();
  for (const [file, raw] of Object.entries(files)) {
    const name = file.split('/').pop()!.replace(/\.md$/, '');
    const dot = name.lastIndexOf('.');
    const suffix = dot === -1 ? '' : name.slice(dot + 1);
    const locale: Locale = dot !== -1 && isSupportedLocale(suffix) ? suffix : defaultLocale;
    const slug = dot !== -1 && isSupportedLocale(suffix) ? name.slice(0, dot) : name;
    if (!byLocale.has(locale)) byLocale.set(locale, new Map());
    byLocale.get(locale)!.set(slug, build(slug, raw, locale));
  }
  return byLocale;
}
